<!--tab-->
<template>
  <div class="data-card-tab">
    <template v-for="(item,index) in tabList">
      <div
        :id="name+index"
        :key="index"
        :class="['data-card-tab-item',{'data-card-tab-active':curIndex==index}]"
        @click="onSwitchTab(index)"
      >{{item}}</div>
      <div class="data-card-tab-space" id="tab-space" :key="index+'space'"></div>
    </template>

    <div
      ref="line"
      class="data-card-tab-line"
      :style="'width:'+width+'px;transform:translateX('+left+'px);transition-duration: 0.3s;height:2px;'"
    ></div>
  </div>
</template>

<script>
    export default {
        components: {},
        props: {
            // 数据
            tabList: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            name: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                curIndex: 0,
                width: 0,
                left: 0
            };
        },
        computed: {},
        methods: {
            onSwitchTab (idx) {
                this.switchTab(idx);
                this.$emit('onSwitch', idx);
            },
            switchTab (index) {
                this.curIndex = index;
                let length = 0;
                for (let i = 0; i < this.tabList.length; i++) {
                    let tabDiv = document.querySelector('#' + this.name + i);
                    if (i < index) {
                        length +=
                            tabDiv.offsetWidth +
                            document.querySelector('#tab-space').offsetWidth;
                    } else if (i === index) {
                        this.width = tabDiv.offsetWidth;
                    }
                }
                this.left = length;
            }
        },
        mounted () {
            this.switchTab(0);
        }
    };
</script>

<style scoped lang="less">
.data-card-tab {
  position: relative;
  overflow-x: scroll;
  white-space: nowrap; /*不换行*/
  height: 50px;

  &-item {
    display: inline-block;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: rgba(51, 51, 51, 1);
    line-height: 50px;
    text-align: left;
  }
  &-space {
    display: inline-block;
    width: 16px;
  }
  &-active {
    color: rgba(54, 179, 116, 1);
    font-weight: 700;
  }
  &-line {
    position: absolute;
    bottom: 12px;
    left: 0;
    width: 56px;
    height: 2px;
    background: rgba(54, 179, 116, 1);
  }
}
.data-card-tab::-webkit-scrollbar {
  display: none;
}
</style>
